<link rel="ractive" href="../r-page.html">

<div class="c-coming-soon">
	<div class="container">
		<h1 class="page-title">{{title}}</h1>

		<div class="box box-featured">
			<i class="fa fa-envelope" aria-hidden="true"></i>
			<span class="box-headline"> Want to hear about the most important news? </span>
			<a class="box-action" target="_blank" rel="noopener noreferrer" href="https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736">Subscribe to our newsletter.</a>
			<span class="box-note">No more than a few emails per year.</span>
		</div>
	</div>
</div>
